define('sentient/aba/models/SessionScriptModel',[
    'underscore',
    'backbone',
    'loglevel',
    'jquery'
], function(_, Backbone, log, $) {
    var SessionScriptModel = Backbone.Model.extend({
        noop: {
            'type': 'noop',
            'options': {}
        },
        defaults: {
            RespId: '',
            ProjectId: '',
            Ex: [],
            sessionScript: [this.noop],
            stepCount: -1
        },
        initialize: function() {
            this.set('sessionScript', [this.noop]);
        },
        serviceHost: '//api.sds-aba.com',
        urlRoot: '/projects/session',
        url: function() {
            var base = _.result(this, 'serviceHost') + _.result(this, 'urlRoot') || urlError();
            var ex = this.get('Ex').slice(0); //Clone the array so we are not braking our own data with the shift()
            return [
                base,
                encodeURIComponent(this.get('ProjectId')),
                _.foldl(
                    ex,
                    function(memo, ex) {
                        return memo + '-' + encodeURIComponent(ex);
                    },
                    ex.shift().toString() //Start the fold left with the fist item on the array.
                ),
                encodeURIComponent(this.get('RespId'))
            ].join('/') + '?cache=false';
        },
        sync: function(method, model, options) {
            if (!options.xhrFields) {
                options.xhrFields = {};
            }

            options.xhrFields = _.extend(options.xhrFields, {
                onprogress: $.proxy(function(event) {
                    var url = this.url();
                    //log.debug("SessionScriptModel::sync::onprogress",event.target);
                    //log.debug("SessionScriptModel::sync::onprogress url",url);

                    if (event.lengthComputable) {
                        this.trigger('progress', {
                            'loaded': event.loaded,
                            'total': event.total,
                            'url': url
                        });
                    }

                }, this)
            });
            if (!options.headers) {
                options.headers = {};
            }
            if (typeof window != 'undefined' && typeof window.screen != 'undefined') {
                options.headers = _.extend(options.headers, {
                    'X-Client-Screen': JSON.stringify(window.screen)
                });
            } else {
                options.headers = _.extend(options.headers, {
                    'X-Client-Screen': JSON.stringify({
                        mode: 'outside browser'
                    })
                });
            }
            var ajax = Backbone.sync.apply(this, arguments);
            //log.debug("SessionScriptModel::sync ajax", ajax);
            ajax.fail($.proxy(function() {
                this.trigger('error', {
                    'message': 'Could not load session. Check you network and try again.'
                });
            }, this));
            return ajax;
        },
        restart: function() {
            this.set('stepCount', -1);
        },
        peekBack: function() {
            if (this.get('stepCount') > 0) {
                return this.get('sessionScript')[this.get('stepCount') - 1];
            } else {
                return this.get('sessionScript')[0];
            }
        },
        stepBack: function() {
            if (this.get('stepCount') > 0) {
                this.set('stepCount', this.get('stepCount') - 1);
                return this.get('sessionScript')[this.get('stepCount')];
            } else {
                return this.noop;
            }
        },
        stepForward: function() {
            if (this.get('stepCount') < this.get('sessionScript').length) {
                this.set('stepCount', this.get('stepCount') + 1);
                return this.get('sessionScript')[this.get('stepCount')];
            } else {
                return this.noop;
            }
        },
        currentStep: function() {
            return this.get('sessionScript')[this.get('stepCount')];
        },
        getLastSeenType: function(type) {
            var sessionScript = this.get('sessionScript');
            var currentStep = this.get('stepCount');
            for (var i = currentStep; i > 0; i--) {
                if (sessionScript[i] && sessionScript[i].type && sessionScript[i].type == type) {
                    return sessionScript[i];
                }
            }
            return null;
        },
        getAllTaskResources: function() {
            var resources = {};
            var sessionScript = _.chain(this.get('sessionScript'))
                .where({
                    'type': 'task'
                })
                .pluck('options')
                .map(function(options) {
                    return {
                        'name': options.name,
                        'type': options.type,
                        'source': options.source,
                        'correctBucket': options.correctBucket,
                        'timeout': options.timeout,
                        'exerciseId': options.exerciseId,
                        'topBucket': options.bucketTop,
                        'bottomBucket': options.bucketBottom,
                        'targetType': options.target_type,
                    };
                })
                .foldl(function(result, value, index, list) {
                    result['Ex' + value.exerciseId.toString() + ':' + value.name] = value;
                    return result;
                }, {})
                .value();
            return sessionScript;
        },
        getAllPrimeResources: function() {
            var resources = {};
            var sessionScript = _.chain(this.get('sessionScript'))
                .where({
                    'type': 'prime'
                })
                .pluck('options')
                .map(function(options) {
                    return {
                        'name': options.name,
                        'type': options.type,
                        'source': options.source,
                        'primingTime': options.primingTime
                    };
                })
                .foldl(function(result, value, index, list) {
                    result[value.name] = value;
                    return result;
                }, {})
                .value();
            return sessionScript;
        },
        applyOverrides: function(overrides) {
            var sessionScript, primes, options;
            //log.debug('SessionScriptModel::applyOverrides', overrides);
            _.each(overrides, function(value, key, list) {
                if (!isNaN(parseFloat(key)) && isFinite(key)) {
                    var exerciseId = parseInt(key, 10);
                    sessionScript = this.get('sessionScript');
                    //log.debug('SessionScriptModel::applyOverrides exerciseId', {'exerciseId': exerciseId});
                    //log.debug('SessionScriptModel::applyOverrides sessionScript', sessionScript);
                    if (value['primingTime']) {
                        primes = _.where(sessionScript, {
                            'type': 'prime'
                        });
                        options = _.pluck(primes, 'options');
                        options = _.where(options, {
                            'exerciseId': exerciseId
                        });
                        _.each(options, function(element, index, list) {
                            element = _.extend(element, value);
                            log.debug('SessionScriptModel::applyOverrides element', element, value);
                        }, this);
                    }

                } else {
                    sessionScript = this.get('sessionScript');

                    if (value['primingTime']) {
                        primes = _.where(sessionScript, {
                            'type': 'prime'
                        });
                        options = _.pluck(primes, 'options');
                        _.each(options, function(element, index, list) {
                            element = _.extend(element, value);
                            log.debug('primingTime: SessionScriptModel::applyOverrides element', element, value);
                        }, this);
                    }
                    if (value['timeout']) {
                        //log.debug('value',value);
                        tasks = _.where(sessionScript, {
                            'type': 'task'
                        });
                        options = _.pluck(tasks, 'options');
                        _.each(options, function(element, index, list) {
                            element = _.extend(element, value);
                            //log.debug('timeout: SessionScriptModel::applyOverrides element', element,value);
                        }, this);
                    }
                }
            }, this);
        }
    });
    return SessionScriptModel;
});
